<template>
  <el-form-item
    :label="item.label"
    :prop="`${item.field}`"
    :hidden="item.options.hidden"
    v-if="item.showed"
    :rules="[
      {
        required: item.required || false,
        message: item.label + '为必填字段',
      },
    ]"
  >
    <el-input
      v-model="$attrs.model[item.field]"
      :ref="item.field"
      :placeholder="item.options.placeholder"
      :style="{ width: item.options.width }"
      :disabled="item.options.disabled"
      :hidden="item.options.hidden"
      :clearable="item.options.clearable"
    >
    </el-input>
  </el-form-item>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  created() {
    //console.log(this.$attrs);
  },
};
</script>

<style lang="scss" scoped></style>
